
<ion-header mode="ios">
  <app-header [fromPayment]="fromPayment"
              [isHome]="isRestaurant"
              [locationId]="locationId"
              [ordersIsEmpty]="ordersIsEmpty"
              [hideOrdersAhead]="restaurant?.hideOrdersAhead"
              [isCollapse]="!isScrollPositionTop"
              pageName="location"
              showLocationModal="true"
              (clearData)="clearCache($event)">
    <ng-container *ngIf="placeCategoryTabsInHeader && !isStoneCreek ">
      <ng-container *ngTemplateOutlet="categoryTabs"></ng-container>
    </ng-container>
  </app-header>
  <div *ngIf="!placeCategoryTabsInHeader && !isStoneCreek" class="container">
    <ng-container *ngTemplateOutlet="categoryTabs"></ng-container>
  </div>
</ion-header>

<!-- this is actually modal -->
<app-product-modal
  [defaultProduct]="selectedProduct"
  [restaurant]="restaurant"
  [locationId]="locationId"
  [isClosed]="isRestaurantClosed"
  [allowScheduledPickups]="restaurant?.allowScheduledPickups"
  [isMobileEnabled]="restaurant?.isMobileEnabled"
  [isModal]="true"
  [enforceInventory]="restaurant?.enforceInventory"
  [hoursOfOperation]="restaurant?.hoursOfOperation"
  [currencySign]="restaurantStore.restaurantCountryInfo.currencySign"
  [isRestaurantHaveEnabledWorkDays]="isRestaurantHaveEnabledWorkDays"
  *ngIf="isShowProductModal"
  (close)="closeProductModal()"
  (addItem)="onAddItemToCart($event)"
>
</app-product-modal>

<app-tab-modal
  *ngIf="(cartStore.showTabModal && !isShowAgeGateModal && restaurant) || cartStore.tabClosedSuccessful"
  (close)="closeTabModal()"
></app-tab-modal>

<app-age-gate-modal
  *ngIf="isShowAgeGateModal"
  (close)="closeAgeGateModal()"
>
</app-age-gate-modal>

<app-restaurant-closed-modal
  *ngIf="isShowClosedModal"
  [restaurant]="restaurant"
  [filteredWorkHours]="filteredWorkDays"
  (close)="closeRestaurantClosedModal()"
></app-restaurant-closed-modal>
<!--<app-order-status-->
<!--  [fromPayment]="fromPayment"-->
<!--  (ordersQuantity)="checkOrderQuantity($event)"-->
<!--&gt;</app-order-status>-->

<ion-content [scrollEvents]="true" (ionScrollEnd)="changeLastTabFlag()">
  <div class="container container--padding-bottom">
    <ng-container *ngIf="restaurantCategories; else spinner">
      <div *ngFor="let category of restaurantCategories">
        <ng-container *ngTemplateOutlet="renderCategory; context: { category: category, isSubCategory: false }"></ng-container>
      </div>
    </ng-container>
    <ng-template #spinner>
      <div class="spinner-wrapper">
        <app-spinner></app-spinner>
      </div>
    </ng-template>
    <ng-template #renderCategory let-category="category" let-isSubCategory="isSubCategory">
      <div class="menu-items" [id]="'category-' + category.id" [hidden]="!category.items" [class.sub-category-wrap]="isSubCategory">
        <div class="parent-header" (click)="changeCategoryCollapseState(category)">
          <hr *ngIf="isSubCategory" class="hr-wrap"/>
          <div class="menu-items__header">
            <span class="menu-items__header-text" [class.sub-header]="isSubCategory">{{ category.name }}</span>
            <div *ngIf="isCategoriesCollapsable">
              <ng-container *ngIf="category.hideItems; then closeArrow else openArrow"></ng-container>
              <ng-template #closeArrow>
                <img class="image-icon" src="./assets/icon/chevron-forward.svg" alt="">
              </ng-template>
              <ng-template #openArrow>
                <img class="image-icon" src="./assets/icon/chevron-down.svg" alt="">
              </ng-template>
            </div>
          </div>
        </div>

        <div class="items-wrap" *ngIf="!category.hideItems">
          <div class="item-list-container">
            <div class="menu-items__item-wrapper"
                 *ngFor="let product of category.items"
                 [hidden]="!isShowDailyAvailabilityItem(product, restaurant) || hideSoldout(product)"
                 (click)="showProductModal(product)">
              <app-product-details
                [product]="product"
                [truncateDescription]="true"
                [enforceInventory]="isProductSold(product)"
                [currencySign]="restaurantStore.restaurantCountryInfo.currencySign"
                [restaurant]="restaurant"
                [hasPadding]="true"
                [isFavorite]="isFavorite(product)"
                [orderBotUserId]="orderBotUserId"
                [enableFavorite]="restaurant.enableFavoriteItems">
              </app-product-details>
            </div>
          </div>

          <div *ngFor="let subCategory of category.subCategories">
            <ng-container *ngTemplateOutlet="renderCategory; context: { category: subCategory, isSubCategory: true }"></ng-container>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</ion-content>

<ion-footer class="checkout-footer" *ngIf="showCheckout">


  <div class="checkout-footer__container">
    <button class="checkout-footer__button" (click)="goToCheckout()" [disabled]="cartStore.updateCartInProgress">
          <span>
            <ion-icon name="cart"></ion-icon>
            {{cartStore.textForCheckoutBtn}}
          </span>
<!--          <span>-->
<!--            ${{getFormattedPrice(cartStore.totalPrice + cartStore.totalTaxesPrice + cartStore.tip)}}-->
<!--          </span>-->
    </button>
  </div>
</ion-footer>

<ng-template #categoryTabs>
  <div class="container__content unscrollable-content" [class.unscrollable-content--is-collapse]="!isScrollPositionTop">
    <div *ngIf="showCategoryTabsLeftArrow" class="categories__arrow-wrapper">
      <div class="categories__arrow categories__arrow--left">
        <ion-icon name="arrow-back" mode="ios" (click)="scrollToPreviousCategoryTabs()"></ion-icon>
      </div>
    </div>
    <div #categoryWrapper class="categories__wrapper">
      <ul #categoryTabContainer class="categories" *ngIf="restaurantCategories.length">
        <ng-container *ngFor="let category of restaurantCategories; index as i; last as isLast">
          <li #categoryTab class="categories__item" *ngIf="!isHideCategory(category)">
            <button
              #rightButton
              *ngIf="category"
              type="button"
              class="categories__btn"
              [class.categories__btn--is-colapse]="!isScrollPositionTop"
              [class.categories__btn--active]="activeCategoryId === category.id"
              (click)="scrollToCategory(category, isLast)"
            >
              {{category.name}}
            </button>
          </li>
        </ng-container>
      </ul>
    </div>

    <div *ngIf="showCategoryTabsRightArrow" class="categories__arrow-wrapper">
      <div class="categories__arrow categories__arrow--right">
        <ion-icon name="arrow-forward" mode="ios" (click)="scrollToNextCategoryTabs()"></ion-icon>
      </div>
    </div>
  </div>
</ng-template>

<ion-content *ngIf="restaurantStore.isKioskSmsOrder">
  <app-sms-transaction [restaurant]="restaurant" (isLoadedOrder)="orderLoaded($event)">
  </app-sms-transaction>
</ion-content>
